import translate from './gender-group.language';

class GenderGroupController {
	constructor() {
		this.translate = translate;
	}

	$onInit() {
		this.selectedGender = this.selectedGender || 'any';
	}

	/*
     * Change selected gender
     */
	changeGender(gender) {
		if (this.selectedGender !== gender) {
			this.selectedGender = gender;
			if (angular.isFunction(this.onChange))
				this.onChange({
					$event: {
						value: this.selectedGender
					}
				});
		}
	}
}

export default GenderGroupController;



// WEBPACK FOOTER //
// ./~/@front10/healthcare-book/src/app/common/gender-group/gender-group.controller.js